const { sliceArray } = require('../automaticReports')
const path = require('path')

exports.parallel = (report, method, toSlice, ...args) => {
  const cluster = require('cluster')
  const numCPUs = require('os').cpus().length
  return new Promise((resolve, reject) => {
    if (cluster.isPrimary) {
      console.log('parallel with', numCPUs, 'cpus', 'toSlice len', toSlice.length)
      cluster.setupPrimary({ exec: path.resolve(__dirname, 'worker.js') })
      const sliced = toSlice.length > (numCPUs - 1) ? sliceArray(toSlice, toSlice.length / (numCPUs - 1)) : [toSlice]
      console.log('sliced in', sliced.length)
      const _result = []
      let done = 0
      let workerCount = 0
      if (!sliced.length) {
        console.error(report, method, 'got sliced length', sliced.length, toSlice)
        reject(new Error('0 to process'))
      }
      sliced.forEach((slice) => {
        if (!slice.length) {
          console.error(report, method, 'got empty slice', slice)
          reject(new Error('got empty slice'))
        }
        try {
          console.log('forking worker', workerCount++, report, method, slice)
          const worker = cluster.fork()
          worker.send({
            report,
            method,
            args: [slice, ...args]
          })
          worker.on('message', ({ result }) => {
            console.log('received result from worker', worker.process.pid)
            _result.push(result)
            if (++done === sliced.length) {
              resolve(_result.flat())
            }
          })
        } catch (e) {
          console.error(report, method, 'worker', workerCount, 'numCPUs', numCPUs)
          reject(e)
        }
      })
      cluster.on('exit', (worker, code, signal) => {
        console.log('worker died', worker.process.pid, code, signal)
        if (signal === 'SIGKILL') {
          reject(new Error(`Worker died ${worker.process.pid}, code ${code} signal ${signal}`))
        }
      })
    }
  })
}
